const VERSION_DATA_CENTER = "base-platform/v2"
// const bizType= window.sessionStorage.getItem('bizType')

// 添加学生请假申请
export const addApply = {
    url: `/${VERSION_DATA_CENTER}/student/leave/add/apply`,
    method: "POST",
}

// 获取学生请假申请信息
export const applyInfo = {
    url: `/${VERSION_DATA_CENTER}/student/leave/apply/info`
}

// 获取学生请假记录列表 ${id}
// export const applyList = (data = { bizType: bizType }) =>
//   post("student/leave/apply/list", data);

export const applyList = {
    url: `/${VERSION_DATA_CENTER}/student/leave/apply/list`,
    method: "POST",
}

// 获取申请记录列表 (家长端)
export const applyListParent = {
    url: `/${VERSION_DATA_CENTER}/workflow/my/apply/list`,
    method: "POST",
}

// 获取学生请假申请状态列表
export const statusList = {
    url: `/${VERSION_DATA_CENTER}/student/leave/apply/status/list`
}

// 学生请假记录信息下载
export const exportApply = {
    url: `/${VERSION_DATA_CENTER}/student/leave/export/apply`,
    method: "POST",
}

// 与我相关信息下载
export const exportMyRelated = {
    url: `/${VERSION_DATA_CENTER}/student/leave/export/my/related`,
    method: "POST",
}

// 学生请假销假
export const finishApply = {
    url: `/${VERSION_DATA_CENTER}/student/leave/finish/apply`,
    method: "POST",
}

// 获取学生请假与我相关列表
export const myRelatedList = {
    url: `/${VERSION_DATA_CENTER}/student/leave/my/related/list`,
    method: "POST",
}

// 撤销学生请假申请 ${id}
export const leaveRevokeApply = {
    url: `/${VERSION_DATA_CENTER}/student/leave/revoke/apply`,
}

// 保存学生请假审批结果
export const approveResult = {
    url: `/${VERSION_DATA_CENTER}/student/leave/save/approve/result`,
    method: "POST",
}

// 获取学生请假类型信息
export const leaveTypeList = {
    url: `/${VERSION_DATA_CENTER}/student/leave/type/list`,
}

// 获取符合条件的审批流信息
export const workflowCondition = {
    url: `/${VERSION_DATA_CENTER}/workflow/conform/condition`,
    method: "POST",
}

// // 获取记录的审批流详情信息
// export const workflowRecordInfo = (data = { bizType: bizType }) =>
//   post("workflow/record/info", data);
export const workflowRecordInfo = {
    url: `/${VERSION_DATA_CENTER}/workflow/record/info`,
    method: "POST",
}

// 获取当前审批人是否需要指定下级审批人
export const approverInfo = {
    url: `/${VERSION_DATA_CENTER}/workflow/appoint/approver/info`,
    method: "POST",
}
// 获取班级请假记录  老师列表
export const studentLeaveClassRecord = {
    url: `/${VERSION_DATA_CENTER}/student/leave/class/record`,
    method: "POST",
}
//手机验证码
export const commonsmscaptcha = {
    url: `/${VERSION_DATA_CENTER}/base/common/sms/captcha`,
    method: "POST",
}

